(function () {
  if (window.__mpnPdpBadges) return; window.__mpnPdpBadges = true;
  var mq = window.matchMedia('(max-width: 749.98px)');
  function lift() {
    if (!mq.matches) return;
    document.querySelectorAll('media-gallery').forEach(function (g) {
      var host = g.querySelector('slider-component') || g;
      var badges = g.querySelector('.product__media-item .product__badges');
      if (!badges) return;
      var hr = host.getBoundingClientRect();
      var br = badges.getBoundingClientRect();
      if (!br.width || !hr.width) return;
      var top = Math.max(0, Math.round(br.top - hr.top));
      var left = Math.max(0, Math.round(br.left - hr.left));
      host.classList.add('mpn-badges-host');
      host.querySelectorAll(':scope > .product__badges.mpn-badges-float').forEach(function (old) { old.remove(); });
      badges.classList.add('mpn-badges-float');
      badges.style.top = top + 'px';
      badges.style.left = left + 'px';
      host.appendChild(badges);
    });
  }
  /* Masquage supplementaire quand le menu mobile est ouvert */
  function menuState() {
    var open = !!document.querySelector('header-drawer details[open], .menu-drawer-container[open], #Details-menu-drawer-container[open]');
    document.querySelectorAll('.mpn-badges-float').forEach(function (b) { b.style.visibility = open ? 'hidden' : ''; });
  }
  document.addEventListener('toggle', menuState, true);
  document.addEventListener('click', function () { setTimeout(menuState, 60); setTimeout(menuState, 400); }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lift); else lift();
  window.addEventListener('load', lift);
  setTimeout(lift, 1200);
  document.addEventListener('change', function () { setTimeout(lift, 900); }, true);
})();
